/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 4-credit course affects your GPA more than a 1-credit one.`)
};

const es_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una asignatura de 4 créditos afecta más a tu promedio que una de 1 crédito.`)
};

const de_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 4-Credit-Kurs beeinflusst deinen GPA stärker als ein 1-Credit-Kurs.`)
};

const nl_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een vak van 4 studiepunten beïnvloedt je GPA sterker dan een vak van 1 studiepunt.`)
};

const fr_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cours à 4 crédits affecte plus votre GPA qu'un cours à 1 crédit.`)
};

const it_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un corso da 4 crediti influisce sul GPA più di uno da 1 credito.`)
};

const pt_br2_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma disciplina de 4 créditos afeta mais o seu GPA do que uma de 1 crédito.`)
};

const pt_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma disciplina de 4 créditos afeta o seu GPA mais do que uma de 1 crédito.`)
};

const ja_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4単位の科目は1単位の科目よりGPAへの影響が大きくなります。`)
};

const zh_gpa_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 学分课程对 GPA 的影响比 1 学分课程更大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_ex2", locale)
	if (locale === "en") return en_gpa_ex2(inputs)
	if (locale === "es") return es_gpa_ex2(inputs)
	if (locale === "de") return de_gpa_ex2(inputs)
	if (locale === "nl") return nl_gpa_ex2(inputs)
	if (locale === "fr") return fr_gpa_ex2(inputs)
	if (locale === "it") return it_gpa_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_ex2(inputs)
	if (locale === "pt") return pt_gpa_ex2(inputs)
	if (locale === "ja") return ja_gpa_ex2(inputs)
	return zh_gpa_ex2(inputs)
};